import React from 'react';
import { PhoneCountryCodeType } from '@bus/models';
import { createOptionsList } from '../../../services/common/miscUtils';
import { getMaxBirthDate, getMinBirthDate } from '../../../services/common/validation';
import { CorrespondenceMethodEnum, TitleEnum } from '../../../types/forms';
import { DatePickerFormField } from '../../Fieldset/DatePickerFormField';
import { PhoneNumberFormField } from '../../Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';
import { ContactDetailsFormNewModel } from './formModel';

const typeSafeFormFieldName = (formFieldName: keyof ContactDetailsFormNewModel) => formFieldName;

export const createFormInputs = (disableAllFormControls: boolean) => {
  return {
    title: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('title')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="contactDetailsForm:fields:title:label"
        optionList={createOptionsList(TitleEnum, 'customerDetailsForm', 'title')}
      />
    ),
    firstName: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('firstName')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="contactDetailsForm:fields:firstName:label"
        placeholderTranslationKey="contactDetailsForm:fields:firstName:placeholder"
      />
    ),
    lastName: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('lastName')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="contactDetailsForm:fields:lastName:label"
        placeholderTranslationKey="contactDetailsForm:fields:lastName:placeholder"
      />
    ),
    dateOfBirth: () => (
      <DatePickerFormField
        fieldName={typeSafeFormFieldName('dateOfBirth')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="contactDetailsForm:fields:dateOfBirth:label"
        placeholderTranslationKey="contactDetailsForm:fields:dateOfBirth:placeholder"
        maxDate={getMaxBirthDate()}
        minDate={getMinBirthDate()}
      />
    ),
    countryCode: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('countryCode')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="contactDetailsForm:fields:countryCode:label"
        optionList={createOptionsList(PhoneCountryCodeType, 'companyDetailsForm', 'countryCode')}
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('email')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="contactDetailsForm:fields:email:label"
        placeholderTranslationKey="contactDetailsForm:fields:email:placeholder"
        validateOnChange
      />
    ),
    invoiceEmailAddress: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('invoiceEmailAddress')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="contactDetailsForm:fields:invoiceEmailAddress:label"
        placeholderTranslationKey="contactDetailsForm:fields:invoiceEmailAddress:placeholder"
        validateOnChange
      />
    ),
    mobileNumber: () => (
      <PhoneNumberFormField
        fieldName={typeSafeFormFieldName('mobileNumber')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="contactDetailsForm:fields:mobileNumber:label"
        placeholderTranslationKey="contactDetailsForm:fields:mobileNumber:placeholder"
        type="mobile"
      />
    ),
    correspondenceMethod: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('correspondenceMethod')}
        isDisabled={disableAllFormControls}
        labelTranslationKey="contactDetailsForm:fields:correspondenceMethod:label"
        optionList={createOptionsList(CorrespondenceMethodEnum, 'companyDetailsForm', 'correspondenceMethod')}
      />
    ),
  };
};
